import parse, { HTMLReactParserOptions } from 'html-react-parser';
import { stripHtml } from 'string-strip-html';

export const safeParseHtml = (html: string | null | undefined, options?: HTMLReactParserOptions) => parse(html || '', options);

export const safeStripHtml = (html: string | null | undefined) => stripHtml(html || '').result;
